import type { ReactNode } from "react";
import React, { useContext } from "react";

import type { OdigeoRouterNavigate } from "./router";
import type { RouterHook } from "./UseRouterContext";
import {
  OdigeoRouterNavigateContext,
  UseRouterContext,
} from "./UseRouterContext";

interface OdigeoRouterNavigateProviderProps {
  odigeoNavigate: OdigeoRouterNavigate;
  children: ReactNode;
}

export const OdigeoRouterNavigateProvider = ({
  odigeoNavigate,
  children,
}: OdigeoRouterNavigateProviderProps) => (
  <OdigeoRouterNavigateContext.Provider value={odigeoNavigate}>
    {children}
  </OdigeoRouterNavigateContext.Provider>
);

export const useRouter: RouterHook = () => {
  const useRouterHook = useContext(UseRouterContext);
  return useRouterHook();
};
